// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Ir1X","requiredAsterisk":"Info_requiredAsterisk__22aEk"};